import React from 'react';
import styled from 'styled-components';

import Card from '../CardPyramid';
import CardContent from '../CardContent';
import Container from '../Container';
import '../../../src/sonic.css';

export interface ModalProps {
  children?: React.ReactNode;
  onDismiss?: () => void;
}

interface StyledModalProps {
  children?: React.ReactNode;
}

const StyledModal = styled.div<StyledModalProps>`
  border-radius: 12px;
  position: relative;
`;

const Modal = ({ children, onDismiss }: ModalProps) => {
  const hasChildren = React.Children.count(children) > 0;

  return (
    <Container size="sm">
      <StyledModal>
        <Card>
          <CardContent>
            {hasChildren ? <>{children}</> : null}
          </CardContent>
        </Card>
      </StyledModal>
    </Container>
  );
};

Modal.defaultProps = {
  children: null,
  onDismiss: undefined,
};

export default Modal;
